// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__1eAtC","cover":"Intro_cover__2oNKg"};